import React from 'react';

const RenderResultDesc = ({ result }) => {
  return (
    <div>
      {result <= 25 ? (
        <div>
          Có khá ít sinh viên Y chọn giống bạn. Bạn rất đặc biệt. Bạn có lối suy
          nghĩ riêng, luôn muốn tìm một con đường mới so với đại đa số những
          người khác. Ngành Y vẫn luôn cần những sự đổi mới và có thể bạn là
          người đó đấy!
        </div>
      ) : result <= 50 ? (
        <div>
          Wow! Kết quả của bạn giống với phần khá cao số sinh viên được khảo
          sát. Một con số không hề thấp đâu nha! Ngành Y và bạn có nhiều nét
          tương đồng và muốn biết những nét tương đồng đó là gì, hãy cùng theo
          dõi những hoạt động của fanpage MedX.vn nhé!
        </div>
      ) : result <= 75 ? (
        <div>
          Thật ấn tượng! Bạn có gene “ngành” rồi đó {'=))'} Hơn một nửa của bạn
          là thuộc “ngành” rồi. Thật mong chờ được chào đón bạn gia nhập Cộng
          đồng học Y - Dược cùng MedX đó nha {'=)))'}
        </div>
      ) : (
        <div>
          {' '}
          Wow It’s a match! Bạn và “ngành” đều đã quẹt phải nhau rồi đấy! Hãy
          cùng “cọ xát” thêm để hiểu về nhau hơn nhé{' '}
        </div>
      )}
    </div>
  );
};

export default RenderResultDesc;
